import { getDefaultState } from "./moduleReportFormState";

export default {
	SET_REPORT_FORMS: (state, reportForms) => {
		state.reportForms = reportForms;
	},

	SET_TOTAL_REPORT_FORMS: (state, total) => {
		state.total = total;
	},

	ADD_REPORT_FORM: (state, newReportForm) => {
		state.reportForms = [newReportForm, ...state.reportForms];
	},

	UPDATE_REPORT_FORM: (state, reportForm) => {
		const index = state.reportForms.findIndex(t => t.id == reportForm.id);
		if (index !== -1) {
			Object.assign(state.reportForms[index], { ...state.reportForms[index], ...reportForm });
		}
	},

	DELETE_REPORT_FORM(state, reportFormId) {
		state.reportForms = state.reportForms.filter(reportForm => reportForm.id !== reportFormId);
	},

	RESET_STATE(state) {
		Object.assign(state, getDefaultState());
	}
};
